module.exports = __webpack_public_path__ + "static/media/the-dutch-square.f9ca48c6.png";